// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import assetStatusEntity from './entities/asset-status.json';
import assetStatusMenu from '../pages/asset-status/menu.json';
import assetStatusFullForm from '../pages/asset-status/forms/full.json';
import assetStatusContextForm from '../pages/asset-status/forms/context.json';
import assetStatusMiniForm from '../pages/asset-status/forms/mini.json';
import assetStatusLookupForm from '../pages/asset-status/forms/lookup.json';
import assetStatusTableView from '../pages/asset-status/views/table.json';
import assetStatusDashboardView from '../pages/asset-status/views/dashboard.json';

/** Тип запису «Стан майна» зі сторінками пакета: меню, форми та подання з pages/asset-status/. */
export const assetStatusDefinition: IRecordTypeDefinition = {
  ...assetStatusEntity,
  views: assembleViewSet({
      table: assetStatusTableView,
      dashboard: assetStatusDashboardView,
  }),
  form: assetStatusFullForm,
  forms: { full: assetStatusFullForm, context: assetStatusContextForm, mini: assetStatusMiniForm, lookup: assetStatusLookupForm },
  menu: assetStatusMenu,
} as IRecordTypeDefinition;
